import { useContext } from "react";

import { AppThemeContext } from "./provider";

export const useAppTheme = () => {
  const state = useContext(AppThemeContext);

  return state;
};
